export const getCulture = (alpha2Code: string) => {
  switch (alpha2Code?.toLowerCase()) {
    case 'en':
      return 'en'
    case 'us':
      return 'en-US'
    case 'gb':
      return 'en-GB'
    case 'int':
      return 'en-001'
    default:
      return 'en'
  }
}
